module.exports = __webpack_public_path__ + "img/total_dark.b520c81f.svg";